(() => {
  const lifetime = 30 * 60 * 1000;
  const initialise = (root = document) => {
    root.querySelectorAll('form[data-fauniva-trade-form]').forEach((form) => {
      if (form.dataset.tradeReady) return;
      form.dataset.tradeReady = 'true';
      const key = 'fauniva:trade-enquiry:' + window.location.pathname + ':v1';
      const fields = Array.from(form.elements).filter((field) =>
        field.name?.startsWith('contact[') &&
        field.type !== 'hidden' &&
        ['INPUT', 'SELECT', 'TEXTAREA'].includes(field.tagName)
      );
      const success = form.querySelector('[data-trade-success]');
      const error = form.querySelector('[data-trade-error]');
      const clear = () => { try { sessionStorage.removeItem(key); } catch {} };
      if (success) {
        clear();
        fields.forEach((field) => { field.value = ''; });
      } else {
        try {
          const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
          if (saved && typeof saved.time === 'number' && Date.now() - saved.time >= 0 && Date.now() - saved.time < lifetime && saved.values && typeof saved.values === 'object') {
            fields.forEach((field) => {
              const value = saved.values[field.name];
              if (!field.value && typeof value === 'string') field.value = value;
            });
          } else if (saved) clear();
        } catch { clear(); }
      }
      form.addEventListener('submit', () => {
        const values = {};
        fields.forEach((field) => { values[field.name] = field.value; });
        try { sessionStorage.setItem(key, JSON.stringify({ time: Date.now(), values })); } catch {}
      });
      const message = success || error;
      if (message) requestAnimationFrame(() => message.focus());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
